
/**
 * @description page公用module
 */

/***************************** 第三方样式文件 ************************************/

import 'bootstrap/dist/css/bootstrap.css';

import 'angular-ui-bootstrap/dist/ui-bootstrap-csp.css';

import 'sweetalert2/dist/sweetalert2.css';

import 'animate.css';

/***************************** QP外部样式文件 ************************************/

import '../../qp-ui-bootstrap/message-fadeindown/qp-message-fadeindown.less'

/***************************** 常量 ************************************/

import { restRuntime } from './rest-runtime.value';

/***************************** JS文件 ************************************/

import 'reflect-metadata';

import angular from 'angular';

import 'jquery';

import 'bootstrap';

import 'angular-ui-bootstrap';

import 'qp-debounce-throttle';

import "angular-animate";

import 'angular-translate';

import "qp-msg-prompt";

/***************************** Module ************************************/

import { CommonModule } from '../common/common.module';

import { mainModule } from './main.module';

import { messageFadeindownModule } from '../../qp-ui-bootstrap/message-fadeindown';

import { qpuiModule } from '../../qp-ui-bootstrap';

import { name as storage } from "@modules/storage/storage.module";

import { module_name as loggerModule } from "@core/logger/index.bootstrap";

import { module_name as qpThrottle } from "@qpUIs/qp-throttle/index.bootstrap";

/************************************** Service ***********************************************/

import { RuntimeContext } from "./runtime-context.service";

import { injector } from '../base/AppConfiguration';

import { UserManager } from '../user/manager/user.manager';
import { HeaderObjectTreeService } from './header/header-object-tree.service';
import { name as accessor } from "@modules/accessor/accessor.module";
import { RestfulAccessorProvider } from '@core/data-access/restful';
import { ProductCatalogRestServiceConfig } from '@modules/catalog/product-catalog/rest/product-catalog-rest.config';
import { PageModule_name as header } from './header/header.module';
import { PageModule_name as footer } from './footer/footer.module';
import { userModule } from '@modules/user/user.module';


/************************************** 内容注册 ***********************************************/

/**
 * @deprecated
 */
let PageModule = angular.module("qpmn-pages", ['ui.bootstrap', 'qpDebounceThrottle', "ngAnimate", "pascalprecht.translate", userModule.name, CommonModule.name, mainModule.name, messageFadeindownModule.name, qpuiModule.name, storage, header, loggerModule, footer, qpThrottle])

PageModule.service({
    runtimeContext: RuntimeContext,
    userManager: UserManager,
    // headerObjectTree: HeaderObjectTreeService
})

PageModule.value("restRuntime", restRuntime);
PageModule.config(injector)

window.__btnTextTranslate ||= <{
    cancelButtonText: string;
    confirmButtonText: string;
}>{
        cancelButtonText: "Cancel",
        confirmButtonText: "OK"
    };

void PageModule.run(["$translate", "$timeout", function ($translate, $timeout) {
    window.__btnTextTranslate = {
        cancelButtonText: $translate.instant("QP_ALERT_PROMPT_CANCEL"),
        confirmButtonText: $translate.instant("QP_ALERT_PROMPT_OK"),
    };
}]);

if (!window["__qpAlertPrompt"]) {
    // @ts-ignore
    window.__qpAlertPrompt = window.qpAlertPrompt;

    // cache
    // @ts-ignore
    window._qpAlertPrompt = new Proxy(window.__qpAlertPrompt, {
        get(target, prop) {
            if (prop === "__isProxied") {
                return true;
            }
            if (prop in target) {
                return (title: string, text: string, confirmCallback?: qpAlertPrompt.ModalCallback | undefined, cancelCallback?: qpAlertPrompt.ModalCallback | undefined, extendCfg?: qpAlertPrompt.AlertPromptConfig | undefined) => {
                    target[prop](title, text, confirmCallback, cancelCallback, { ...window.__btnTextTranslate, ...extendCfg });
                };
            }
            console.warn("unknown key call window.qpAlertPrompt", prop);
            return undefined;
        }
    });
}

if (!window.qpAlertPrompt["__isProxied"]) {
    Object.defineProperty(window, "qpAlertPrompt", {
        get() {
            // @ts-ignore
            return window._qpAlertPrompt;
        },
        set(value) {
            // 忽略set   
        }
    });
}

export { PageModule }